module.exports = __webpack_public_path__ + "images/iPhone12-stack-with-app-open.png";